import type React from 'react';

import { css } from '@clubspark-react/ui/core';
import ArrowRight from '@mui/icons-material/ArrowRight';

import StandardButton, { type StandardButtonProps } from 'components/buttons/StandardButton';

const styles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '&:not(:first-of-type)': {
    marginTop: '1 rem',
  },
});

const PlayerButton: React.FC<React.PropsWithChildren<StandardButtonProps>> = ({ ...props }) => {
  return (
    <StandardButton fullWidth className={styles()} endIcon={<ArrowRight />} size="large" variant="tertiary" {...props}>
      {props.children}
    </StandardButton>
  );
};

export default PlayerButton;
